import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')

if (isFirefox) {
  const style = document.createElement('style')
  style.innerHTML = `
    html {
      scrollbar-width: thin;
      scrollbar-color: #9801e7 #20252b;
    }
  `
  document.head.appendChild(style)
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
